import { useContext, useEffect, useState } from "react";
import ReferralPosListItem from "./common/ReferralPosListItem";
import { AppContext } from "./global/context";

export default function LeaderboardPage() {
  const appState = useContext(AppContext);
  const [referrals, setReferrals] = useState(/** @type {import("./context").ListItem[]} */ ([]));

  useEffect(() => {
    if (appState) {
      setReferrals(appState.list);
    }
  }, [appState]);

  return (
    <div id="leaderboard-page">
      <h4 id="leaderboard-page-heading">Referral Leaderboard</h4>
      <p id="leaderboard-page-text">
        Know which of your fellow comrades have given referrals and are going to win ReSOPs
      </p>
      <div id="leaderboard-page-list-header">
        <span>Rank</span>
        <span>Comrade</span>
        <span>Referrals Given</span>
      </div>
      <div>
        {referrals.map((item, i) => (
          <ReferralPosListItem
            key={item.uuid}
            img={item.imageURL}
            name={item.name}
            count={item.referrals}
            position={i + 1}
            designation={item.designation}
          />
        ))}
      </div>
    </div>
  );
}
